import { siteLocale } from './site-locale.js';
import { toIsoDate } from './range-calendar.js';

// The month grid requires Gregorian dates and Latin digits in every locale.
export function dateFormat(options) {
    if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function') {
        return new Intl.DateTimeFormat(siteLocale(), { calendar: 'gregory', numberingSystem: 'latn', ...options });
    }

    return {
        format(date) {
            const iso = toIsoDate(date);
            return options.day ? iso : iso.slice(0, 7);
        }
    };
}

export function formatNumber(value) {
    if (typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function') {
        return new Intl.NumberFormat(siteLocale(), { numberingSystem: 'latn' }).format(value);
    }
    return String(value);
}

// Only integer night counts reach the catalog's select expressions.
export function nightPluralForm(count) {
    if (typeof Intl !== 'undefined' && typeof Intl.PluralRules === 'function') {
        return new Intl.PluralRules(siteLocale()).select(count);
    }

    const language = siteLocale().split(/[-_]/)[0].toLowerCase();
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (language === 'ru' || language === 'uk' || language === 'pl') {
        if (language !== 'pl' && mod10 === 1 && mod100 !== 11) return 'one';
        return mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14) ? 'few' : 'other';
    }
    if (language === 'cs') return count >= 2 && count <= 4 ? 'few' : 'other';
    if (language === 'ro') return count === 0 || (mod100 >= 1 && mod100 <= 19) ? 'few' : 'other';
    if (language === 'ar') {
        if (count === 2) return 'two';
        return mod100 >= 3 && mod100 <= 10 ? 'few' : 'other';
    }
    return count === 1 ? 'one' : 'other';
}
